import servise from '@/router/axios'

// 修改当前用户状态
export const updateStatus = (data) => {
  return servise({
    url: '/admin/update/status',
    method: 'PUT',
    data
  })
}

// 获取角色列表
export const sysUserRoleList = (params) => {
  return servise({
    url: '/sysUserRole/list',
    method: 'get',
    params
  })
}

// 获取角色权限列表
export const sysUserRoleMenuList = (params) => {
  return servise({
    url: '/sysUserRole/role/menu/list',
    method: 'get',
    params
  })
}

// 添加新用户
export const addAdmin = (data) => {
  return servise({
    url: '/admin/add',
    method: 'post',
    data
  })
}
// 修改账号信息
export const updateAdmin = (data) => {
  return servise({
    url: '/admin/update',
    method: 'PUT',
    data
  })
}


// 账号管理——数据权限关联列表（媒体/需求方）
export const clientList = (data) => {
  return servise({
    url: '/accountConf/list',
    method: 'post',
    data
  })
}

// 账号管理——保存数据权限关联
export const editClient = (data) => {
  return servise({
    url: '/accountConf/edit',
    method: 'post',
    data
  })
}

// 查询账号数据权限模式
export const getDataScope = (params) => {
  return servise({
    url: '/accountConf/dataScope',
    method: 'get',
    params
  })
}

// 保存账号数据权限模式
export const saveDataScope = (data) => {
  return servise({
    url: '/accountConf/dataScope',
    method: 'post',
    data
  })
}